<template>
  <div :class="{'item-error': item.error}">
    <b-card class="item-card">
      <options :item="item" :level="level"/>

      <h2 class="item-title">Audio</h2>

      <b-container fluid>
        <b-row>
          <b-col cols="12" lg="6" xl="3">
            <audio-preview 
              src="previewSrc" 
              @click.native="displayMedia(true)" />
          </b-col>

          <b-col cols="9" lg="6" xl="3" class="mt-2 mt-lg-0">
            <b-form-group>
              <b-button
                :disabled="saving || fetching"
                @click="showMediaLibrary()">
                Browse Library
              </b-button>
            </b-form-group>

            <span class="name">Name:</span>
            <span v-if="selectedMedia">
              {{ selectedMedia.name }}
            </span>
            <br>
            <span class="name">Size:</span>
            <span v-if="selectedMedia">
              {{ readableFilesize(selectedMedia.size) }}
            </span>
            <br>
            <span class="name">Created:</span>
            <span v-if="selectedMedia">
              {{ readableDate(selectedMedia.created) }}
            </span>
            <validation-errors :validation-errors="item.apiErrors"/>
          </b-col>

          <b-col cols="12" lg="8" xl="4" class="mt-2 mt-xl-0">
            <b-form v-if="formShow" @submit="onSubmit">
              <p> Upload a new file </p>
              <b-form-group>
                <b-form-input
                  v-validate="'required'"
                  id="name-input"
                  :disabled="fetching || saving || item.form.saving"
                  :class="{ 'is-invalid' : errors.has('name') || item.form.apiErrors.name.length }"
                  :value="item.form.fields.name"
                  class="form-control"
                  placeholder="name"
                  type="text"
                  name="name"
                  @input="setName"/>
                <validation-errors :validation-errors="[errors.first('name')]"/>
                <validation-errors v-if="!errors.has('name')" :validation-errors="item.form.apiErrors.name"/>
              </b-form-group>

              <b-form-group>
                <input
                  v-validate="'required|validateAudio|mimes:audio/mpeg,audio/wav'"
                  id="file-input"
                  :disabled="fetching || saving || item.form.saving"
                  :class="{ 'is-invalid' : errors.has('file') || item.form.apiErrors.file.length }"
                  type="file"
                  accept="audio/mpeg,audio/wav"
                  name="file"
                  @change="setFile"/>
                <validation-errors :validation-errors="[errors.first('file')]"/>
                <validation-errors v-if="!errors.has('file')" :validation-errors="item.form.apiErrors.file"/>
              </b-form-group>

              <b-form-group>
                <b-button :disabled="submitDisabled" type="submit" variant="primary">
                  Upload
                  <span v-if="item.form.saving"><i class="fas fa-spinner fa-spin"></i></span>
                </b-button>
              </b-form-group>

              <uploading-audio v-if="item.form.saving"/>
              <form-success :success="item.form.success" class="form-alert">Media Uploaded!</form-success>

            </b-form>

          </b-col>
        </b-row>
      </b-container>
    </b-card>

    <b-modal
      v-model="mediaLibraryVisible"
      title="Media Library"
      centered hide-footer
      size="lg">
      <media-table
        v-if="mediaLibrary.visible"
        :view="mediaView"
        :show-type-select="false"
        :module-id="module.id"
        :ids-to-highlight="idsToHighlight"
        context="selectOne"
        type="audio"
        @selectMedia="setMediaID"/>
    </b-modal>

    <b-modal v-model="showMediaModal"
             :title="name"
             centered 
             hide-footer
             size="md">
      <div class="audio-container">
        <audio id="modalAudio" ref="modalAudio" controls="true">
          <source :src="url" />
        </audio>
      </div>
    </b-modal>

  </div>
</template>

<script>
import mediaMixin from '../../mixins/media-item'
import options from './options'
import audioPreview from '../../../common/audio-preview'
import mediaTable from '../media/table'
import uploadingAudio from '../../../common/form/uploading-audio'
import formSuccess from '../../../common/form/form-success'
import formWrapper from '../../../common/form/form-wrapper'
import validationErrors from '../../../common/form/validation-errors'

export default {
  components: {
    options,
    formSuccess,
    formWrapper,
    audioPreview,
    mediaTable,
    validationErrors,
    uploadingAudio
  },
  mixins: [mediaMixin],
  data () {
    return {
      mediaLibraryVisible: false
    }
  },
  computed: {
    modalAudio () {
      return this.$refs.modalAudio
    }
  },
  watch: {
    showMediaModal: function (val) {
      if (!val) {
        this.modalAudio.pause()
        this.modalAudio.currentTime = 0
      }
    }
  },
  methods: {
    showMediaLibrary () {
      this.mediaLibraryVisible = true
      this.showLibraryModal()
    }
  }
}
</script>

<style scoped>
.audio-container {
  display: flex;
  justify-content: center;
  align-items: center 
}
</style>


// WEBPACK FOOTER //
// src/components/pages/admin/items/audio.vue